import ReactDOM from "react-dom/client";
import React from 'react';
import App from "./App.jsx";

import { Provider } from "react-redux";
import { store, persistor } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";

// Suppress defaultProps warnings from third-party libraries
const originalError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && (args[0].includes('Support for defaultProps') || args[0].includes('validateDOMNesting'))) {
    return;
  }
  originalError(...args);
};

ReactDOM.createRoot(document.getElementById("root")).render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <App/>
        </PersistGate>
    </Provider>
);

